import { useEffect, useState } from 'react';
import { PHONE_ERROR } from '../restaurantPhone';
import { navigate } from '../App';
import { BrandWordmark } from '../components/BrandIdentity';
import { requestRecoverPassword, signInRecover, signUpRecover, updateRecoverPassword } from '../supabase';

export default function RecoverAuth({ initialSignup = false, resetMode = false, entryPoint = '' }) {
  const menuEntry = entryPoint === 'menu';
  const [signup, setSignup] = useState(initialSignup);
  const [forgot, setForgot] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [form, setForm] = useState({ ownerName: '', restaurantName: '', city: '', phone: '', email: '', password: '', website: '' });
  const update = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));

  async function submit(event) {
    event.preventDefault();
    setError(''); setMessage('');
    if (form.website) return;
    setLoading(true);
    try {
      if (resetMode) {
        const { error: authError } = await updateRecoverPassword(form.password);
        if (authError) throw authError;
        navigate('/app');
      } else if (forgot) {
        const { error: authError } = await requestRecoverPassword(form.email);
        if (authError) throw authError;
        setMessage('Ti abbiamo inviato un link sicuro per scegliere una nuova password.');
      } else if (signup) {
        const { data, error: authError } = await signUpRecover(menuEntry ? { ...form, entryPoint: 'menu' } : form);
        if (authError) throw authError;
        if (!data.session) setMessage('Controlla la tua email per confermare l’account. Dopo la conferma tornerai qui.');
      } else {
        const { error: authError } = await signInRecover(form.email, form.password);
        if (authError) throw authError;
      }
    } catch (requestError) {
      setError(translateAuthError(requestError.message));
    } finally { setLoading(false); }
  }

  const title = resetMode ? 'Scegli una nuova password.' : forgot ? 'Recupera l’accesso.' : signup ? (menuEntry ? 'Crea il tuo menù digitale gratuito.' : 'Crea la tua agenda gratuita.') : (menuEntry ? 'Accedi al tuo menù.' : 'Accedi al tuo ristorante.');
  useEffect(() => {
    if (!menuEntry) return undefined;
    const previousTitle = document.title;
    document.title = `${title} | RistoDaily`;
    return () => { document.title = previousTitle; };
  }, [menuEntry, title]);
  return (
    <main className="auth-page">
      <div className="auth-orb auth-orb-one" /><div className="auth-orb auth-orb-two" />
      <button className="brand auth-brand" onClick={() => navigate(menuEntry ? '/menu-digitale' : '/')}><BrandWordmark /></button>
      <section className="auth-card glass-card">
        <div className="auth-copy">
          <p className="eyebrow">{resetMode ? 'NUOVA PASSWORD' : forgot ? 'RECUPERA ACCESSO' : signup ? 'NUOVO RISTORANTE' : 'BENTORNATO'}</p>
          <h1>{title}</h1>
          <p>{resetMode ? 'Usa almeno 8 caratteri.' : forgot ? 'Inserisci l’email dell’account: riceverai un link di recupero.' : menuEntry ? (signup ? 'Parti da una foto o da un PDF, controlla l’anteprima e pubblica quando sei pronto. Nessuna carta richiesta.' : 'Ritrova la tua bozza, aggiorna i piatti e gestisci il menù pubblicato.') : signup ? 'Agenda, tavoli e prenotazioni online a 0 €. Nessuna carta richiesta. L’assistente telefonico è un servizio separato, con attivazione assistita.' : 'Trovi qui prenotazioni, richieste degli ospiti e disponibilità.'}</p>
          {!resetMode && !forgot && <div className="auth-switch">
            <button className={!signup ? 'active' : ''} onClick={() => { setSignup(false); setError(''); }}>Accedi</button>
            <button className={signup ? 'active' : ''} onClick={() => { setSignup(true); setError(''); }}>Nuovo ristorante</button>
          </div>}
        </div>
        <form className="auth-form" onSubmit={submit}>
          {signup && !resetMode && !forgot && <>
            <label>Il tuo nome<input required value={form.ownerName} onChange={update('ownerName')} autoComplete="name" placeholder="Mario Rossi" /></label>
            <label>Nome del ristorante<input required value={form.restaurantName} onChange={update('restaurantName')} placeholder="Osteria del Centro" /></label>
            <div className="form-row"><label>Città<input required value={form.city} onChange={update('city')} autoComplete="address-level2" placeholder="Palermo" /></label><label><span id="contact-phone-label">Telefono</span><input required type="tel" value={form.phone} onChange={update('phone')} autoComplete="tel" inputMode="tel" placeholder="+39 3… oppure +39 0…" aria-labelledby="contact-phone-label" aria-describedby="contact-phone-hint" /><small id="contact-phone-hint">Cellulare: +39 3… senza zero. Fisso: conserva lo zero del prefisso.</small></label></div>
            <label className="trap-field" aria-hidden="true">Sito web<input tabIndex="-1" autoComplete="off" value={form.website} onChange={update('website')} /></label>
          </>}
          {!resetMode && <label>Email<input required type="email" value={form.email} onChange={update('email')} autoComplete="email" placeholder="nome@ristorante.it" /></label>}
          {!forgot && <label>{resetMode ? 'Nuova password' : 'Password'}<input required minLength="8" type="password" value={form.password} onChange={update('password')} autoComplete={signup || resetMode ? 'new-password' : 'current-password'} placeholder="Almeno 8 caratteri" /></label>}
          {!signup && !forgot && !resetMode && <button className="auth-forgot" type="button" onClick={() => { setForgot(true); setError(''); setMessage(''); }}>Password dimenticata?</button>}
          {error && <div className="form-alert error" role="alert">{error}</div>}
          {message && <div className="form-alert success" role="status">{message}</div>}
          <button className="button button-large full" disabled={loading}>{loading ? 'Un momento…' : resetMode ? 'Salva nuova password' : forgot ? 'Invia link di recupero' : signup ? 'Crea account gratuito' : 'Accedi'}</button>
          {forgot && <button className="auth-forgot centered" type="button" onClick={() => { setForgot(false); setError(''); setMessage(''); }}>Torna all’accesso</button>}
          {signup && !resetMode && !forgot && <small className="form-legal">Creando l’account accetti i <button type="button" onClick={() => navigate('/termini')}>Termini</button> e dichiari di aver letto la <button type="button" onClick={() => navigate('/privacy')}>Privacy Policy</button>.</small>}
        </form>
      </section>
    </main>
  );
}

function translateAuthError(message = '') {
  if (message === PHONE_ERROR) return PHONE_ERROR;
  if (message.includes('Invalid login credentials')) return 'Email o password non corretti.';
  if (message.includes('already registered')) return 'Esiste già un account con questa email.';
  if (message.includes('Password should')) return 'La password deve contenere almeno 8 caratteri.';
  if (message.includes('rate limit')) return 'Troppi tentativi. Attendi qualche minuto e riprova.';
  return 'Non siamo riusciti a completare l’operazione. Riprova.';
}
